export default "__VITE_ASSET__luuwvyWVpL4bTX5MXmRXrg__";